function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/*
Impulse 1.0.2 © 2025 Ambitious Idea Labs
 */
var symbol = Symbol.for('impulse');

var Store = /*#__PURE__*/function () {
  function Store(ctor, name) {
    _classCallCheck(this, Store);

    this.ctor = ctor;
    this.name = name;
    this.map = new Map();
    this.ctor = ctor;
    this.name = name;
    this.initialize();
  }

  _createClass(Store, [{
    key: "add",
    value: function add(value) {
      var _a;

      (_a = this.value) === null || _a === void 0 ? void 0 : _a.add(value);
    }
  }, {
    key: "value",
    get: function get() {
      return this.map.get(this.name);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      if (!Object.prototype.hasOwnProperty.call(this.ctor, symbol)) {
        this.ctor[symbol] = new Map();
      }

      this.map = this.ctor[symbol];
      if (this.map.has(this.name)) return;
      this.map.set(this.name, new Set());
    }
  }]);

  return Store;
}();

function property() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? String : _ref$type;

  return function (ctor, key) {
    var store = new Store(ctor, 'property');
    store.add({
      key: key,
      type: type
    });
  };
}

function registerElement(name) {
  return function (ctor) {
    try {
      window.customElements.define(name, ctor); // @ts-expect-error Register

      window[ctor.name] = customElements.get(name);
    } catch (error) {
      if (!(error instanceof DOMException && error.name === 'NotSupportedError')) throw error;
    }
  };
}

function target() {
  return function (ctor, key) {
    var store = new Store(ctor, 'target');
    store.add({
      key: key,
      multiple: false
    });
  };
}

function targets() {
  return function (ctor, key) {
    var store = new Store(ctor, 'target');
    store.add({
      key: key,
      multiple: true
    });
  };
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
}; // https://regex101.com/r/noxreJ/1
// capture nos:                 1          2               3                 4    5

var descriptorPattern = /(?:(.+?)?(?:\.(.+?))?(?:@(window|document))?->)?(.+)#(.+)?$/;
var validEventModifiers = ['stop', 'prevent', 'self'];
var validEventOptions = ['capture', 'once', 'passive'];

function parseActionDescriptor(_descriptor) {
  var descriptor = _descriptor.trim();

  var _ref2 = descriptor.match(descriptorPattern) || [],
      _ref3 = _slicedToArray(_ref2, 6),
      eventName = _ref3[1],
      modifiers = _ref3[2],
      eventTarget = _ref3[3],
      identifier = _ref3[4],
      methodName = _ref3[5];

  var modifiersArray = (modifiers === null || modifiers === void 0 ? void 0 : modifiers.split('.')) || [];
  var eventModifiers = modifiersArray.filter(function (m) {
    return validEventModifiers.includes(m);
  });
  return {
    eventName: eventName,
    eventModifiers: eventModifiers,
    eventListenerOptions: getEventListenerOptions(modifiersArray),
    eventTarget: getEventTarget(eventTarget),
    methodName: methodName,
    identifier: identifier
  };
}

var modifierGuards = {
  prevent: function prevent(event) {
    return Boolean(event.preventDefault());
  },
  stop: function stop(event) {
    return Boolean(event.stopPropagation());
  },
  self: function self(event) {
    return event.target !== event.currentTarget;
  }
};

function getEventListenerOptions(modifiers) {
  var options = {};

  var _iterator = _createForOfIteratorHelper(modifiers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var modifier = _step.value;

      if (validEventOptions.includes(modifier)) {
        options[modifier] = true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return options;
}

function getEventTarget(target) {
  if (target === 'window') {
    return window;
  } else if (target === 'document') {
    return document;
  }
}

var SetMap = /*#__PURE__*/function () {
  function SetMap() {
    _classCallCheck(this, SetMap);

    this.map = new Map();
  }

  _createClass(SetMap, [{
    key: "add",
    value: function add(key, value) {
      findOrCreate(this.map, key).add(value);
    }
  }, {
    key: "delete",
    value: function _delete(key, value) {
      var _a;

      findOrCreate(this.map, key).delete(value); // Delete map item

      if (((_a = this.get(key)) === null || _a === void 0 ? void 0 : _a.size) === 0) {
        this.deleteKey(key);
      }
    }
  }, {
    key: "deleteKey",
    value: function deleteKey(key) {
      this.map.delete(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: "getValuesForKey",
    value: function getValuesForKey(key) {
      var values = this.map.get(key);
      return values ? Array.from(values) : [];
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.map.keys());
    }
  }, {
    key: "values",
    get: function get() {
      var sets = Array.from(this.map.values());
      return sets.reduce(function (values, set) {
        return values.concat(Array.from(set));
      }, []);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.map.get(key);
    }
  }, {
    key: "has",
    value: function has(key, value) {
      var _a;

      return !!((_a = this.get(key)) === null || _a === void 0 ? void 0 : _a.has(value));
    }
  }]);

  return SetMap;
}();

function findOrCreate(map, key) {
  var values = map.get(key);

  if (!values) {
    values = new Set();
    map.set(key, values);
  }

  return values;
}

var EventListener = /*#__PURE__*/function () {
  function EventListener(instance, options) {
    _classCallCheck(this, EventListener);

    this.instance = instance;
    this.eventTarget = options.eventTarget;
    this.eventName = options.eventName;
    this.eventModifiers = options.eventModifiers;
    this.eventListenerOptions = options.eventListenerOptions;
    this.methodName = options.methodName;
  }

  _createClass(EventListener, [{
    key: "start",
    value: function start() {
      this.eventTarget.addEventListener(this.eventName, this, this.eventListenerOptions);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.eventTarget.removeEventListener(this.eventName, this, this.eventListenerOptions);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var fn = this.instance[this.methodName];
      if (typeof fn !== 'function') return;

      var _iterator2 = _createForOfIteratorHelper(this.eventModifiers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var modifier = _step2.value;
          var guard = modifierGuards[modifier];
          if (guard === null || guard === void 0 ? void 0 : guard(event)) return;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      fn.call(this.instance, event);
    }
  }]);

  return EventListener;
}();

var ElementObserver = /*#__PURE__*/function () {
  function ElementObserver(element, delegate, observerOptions) {
    var _this = this;

    _classCallCheck(this, ElementObserver);

    this.element = element;
    this.delegate = delegate;
    this.observerOptions = observerOptions;
    this.elements = new Set();
    this.started = false;
    this.element = element;
    this.delegate = delegate;
    this.observer = new MutationObserver(function (mutations) {
      return _this.processMutations(mutations);
    });
    this.observerOptions = observerOptions;
  }

  _createClass(ElementObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        this.observer.observe(this.element, Object.assign({
          childList: true,
          subtree: true
        }, this.observerOptions)); // Initialize elements that are already in the DOM.

        this.initializeElements();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.observer.takeRecords();
        this.observer.disconnect();
        this.started = false;
      }
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      var _iterator3 = _createForOfIteratorHelper(this.getMatchingElements()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var element = _step3.value;
          this.addElement(element);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "processMutations",
    value: function processMutations(mutations) {
      if (this.started) {
        var _iterator4 = _createForOfIteratorHelper(mutations),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var mutation = _step4.value;

            if (mutation.type === 'attributes' && mutation.target instanceof Element) {
              this.processAttributeChange(mutation.target, mutation.attributeName);
            } else if (mutation.type === 'childList') {
              this.processRemovedNodes(mutation.removedNodes);
              this.processAddedNodes(mutation.addedNodes);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "processAttributeChange",
    value: function processAttributeChange(element, attributeName) {
      if (this.elements.has(element)) {
        // If the delegate does not implement elementAttributeChanged, remove the element.
        if (this.delegate.elementAttributeChanged && this.matchesElement(element)) {
          this.delegate.elementAttributeChanged(element, attributeName || '');
        } else {
          this.removeElement(element);
        }
      } else if (this.matchesElement(element)) {
        this.addElement(element);
      }
    }
  }, {
    key: "processRemovedNodes",
    value: function processRemovedNodes(nodes) {
      for (var _i2 = 0, _Array$from = Array.from(nodes); _i2 < _Array$from.length; _i2++) {
        var node = _Array$from[_i2];
        var element = this.elementFromNode(node);

        if (element) {
          var _iterator5 = _createForOfIteratorHelper(this.getMatchingElements(element)),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var ele = _step5.value;
              this.removeElement(ele);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }
    }
  }, {
    key: "processAddedNodes",
    value: function processAddedNodes(nodes) {
      for (var _i3 = 0, _Array$from2 = Array.from(nodes); _i3 < _Array$from2.length; _i3++) {
        var node = _Array$from2[_i3];
        var element = this.elementFromNode(node);

        if (element) {
          var _iterator6 = _createForOfIteratorHelper(this.getMatchingElements(element)),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var ele = _step6.value;
              this.addElement(ele);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      }
    }
  }, {
    key: "getMatchingElements",
    value: function getMatchingElements() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;

      var _a, _b;

      return ((_b = (_a = this.delegate).getMatchingElements) === null || _b === void 0 ? void 0 : _b.call(_a, element)) || [];
    }
  }, {
    key: "matchesElement",
    value: function matchesElement(element) {
      var _a, _b, _c;

      return (_c = (_b = (_a = this.delegate).matchesElement) === null || _b === void 0 ? void 0 : _b.call(_a, element)) !== null && _c !== void 0 ? _c : true;
    }
  }, {
    key: "addElement",
    value: function addElement(element) {
      var _a, _b;

      if (!this.elements.has(element) && this.elementIsActive(element)) {
        this.elements.add(element);
        (_b = (_a = this.delegate).elementConnected) === null || _b === void 0 ? void 0 : _b.call(_a, element);
      }
    }
  }, {
    key: "removeElement",
    value: function removeElement(element) {
      var _a, _b;

      if (this.elements.has(element)) {
        this.elements.delete(element);
        (_b = (_a = this.delegate).elementDisconnected) === null || _b === void 0 ? void 0 : _b.call(_a, element);
      }
    }
  }, {
    key: "elementFromNode",
    value: function elementFromNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        return node;
      }

      return undefined;
    }
  }, {
    key: "elementIsActive",
    value: function elementIsActive(element) {
      if (element.isConnected !== this.element.isConnected) {
        return false;
      }

      return this.element.contains(element);
    }
  }]);

  return ElementObserver;
}();

var AttributeObserver = /*#__PURE__*/function () {
  function AttributeObserver(instance, attributeName, delegate) {
    _classCallCheck(this, AttributeObserver);

    this.instance = instance;
    this.attributeName = attributeName;
    this.delegate = delegate;
    this.instance = instance;
    this.attributeName = attributeName;
    this.elementObserver = new ElementObserver(this.instance, this, {
      attributeFilter: [this.attributeName]
    });
    this.delegate = delegate;
  }

  _createClass(AttributeObserver, [{
    key: "start",
    value: function start() {
      this.elementObserver.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.elementObserver.stop();
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(element) {
      var _a, _b;

      (_b = (_a = this.delegate).elementConnected) === null || _b === void 0 ? void 0 : _b.call(_a, element);
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(element) {
      var _a, _b;

      (_b = (_a = this.delegate).elementDisconnected) === null || _b === void 0 ? void 0 : _b.call(_a, element);
    }
  }, {
    key: "elementAttributeChanged",
    value: function elementAttributeChanged(element, attributeName) {
      var _a, _b;

      if (attributeName === this.attributeName) {
        (_b = (_a = this.delegate).elementAttributeChanged) === null || _b === void 0 ? void 0 : _b.call(_a, element, attributeName);
      }
    }
    /**
     * Returns the elements that match the selector. Called by the ElementObserver.
     */

  }, {
    key: "getMatchingElements",
    value: function getMatchingElements(element) {
      var elements = Array.from(element.querySelectorAll("[".concat(this.attributeName, "]")));

      if (element.hasAttribute(this.attributeName)) {
        elements.unshift(element);
      }

      return elements;
    }
    /**
     * Returns true if the element has the attribute. Called by the ElementObserver.
     */

  }, {
    key: "matchesElement",
    value: function matchesElement(element) {
      return element.hasAttribute(this.attributeName);
    }
  }]);

  return AttributeObserver;
}();

var TokenListObserver = /*#__PURE__*/function () {
  function TokenListObserver(element, attributeName, delegate) {
    _classCallCheck(this, TokenListObserver);

    this.element = element;
    this.attributeName = attributeName;
    this.delegate = delegate;
    this.element = element;
    this.attributeName = attributeName;
    this.delegate = delegate;
    this.elementTokens = new SetMap();
  }

  _createClass(TokenListObserver, [{
    key: "start",
    value: function start() {
      if (!this.attributeObserver) {
        this.attributeObserver = new AttributeObserver(this.element, this.attributeName, this);
        this.attributeObserver.start();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.attributeObserver) {
        this.attributeObserver.stop();
        this.attributeObserver = undefined;
      }
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(element) {
      var _this2 = this;

      var tokens = this.readTokensForElement(element);
      tokens.forEach(function (token) {
        return _this2.tokenMatched(token);
      });
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(element) {
      var _this3 = this;

      // Instead of removing the value, if we remove the attribute itself, the `readTokensForElement` will not return
      // any tokens. Hence, we need to get the tokens from the state.
      var tokens = this.elementTokens.getValuesForKey(element);
      tokens.forEach(function (token) {
        return _this3.tokenUnmatched(token);
      });
    }
  }, {
    key: "elementAttributeChanged",
    value: function elementAttributeChanged(element) {
      var _this4 = this;

      var oldTokens = this.elementTokens.getValuesForKey(element);
      var newTokens = this.readTokensForElement(element);

      var _compareTokens = compareTokens(oldTokens, newTokens),
          _compareTokens2 = _slicedToArray(_compareTokens, 2),
          added = _compareTokens2[0],
          removed = _compareTokens2[1];

      removed.forEach(function (token) {
        return _this4.tokenUnmatched(token);
      });
      added.forEach(function (token) {
        return _this4.tokenMatched(token);
      });
    }
  }, {
    key: "tokenMatched",
    value: function tokenMatched(token) {
      var _a, _b;

      this.elementTokens.add(token.element, token);
      (_b = (_a = this.delegate).tokenMatched) === null || _b === void 0 ? void 0 : _b.call(_a, token);
    }
  }, {
    key: "tokenUnmatched",
    value: function tokenUnmatched(token) {
      var _a, _b;

      this.elementTokens.delete(token.element, token);
      (_b = (_a = this.delegate).tokenUnmatched) === null || _b === void 0 ? void 0 : _b.call(_a, token);
    }
  }, {
    key: "readTokensForElement",
    value: function readTokensForElement(element) {
      var tokenString = element.getAttribute(this.attributeName) || '';
      return parseTokenString(tokenString, element, this.attributeName);
    }
  }]);

  return TokenListObserver;
}();

function parseTokenString(tokenString, element, attributeName) {
  return tokenString.trim().split(/\s+/).filter(function (content) {
    return content.length;
  }).map(function (content) {
    return {
      element: element,
      attributeName: attributeName,
      content: content
    };
  });
}

function compareTokens(newTokens, oldTokens) {
  // Convert arrays to sets for O(1) lookup time
  var newTokensSet = new Set(newTokens.map(function (_ref4) {
    var content = _ref4.content;
    return content;
  }));
  var oldTokensSet = new Set(oldTokens.map(function (_ref5) {
    var content = _ref5.content;
    return content;
  }));
  var added = oldTokens.filter(function (token) {
    return !newTokensSet.has(token.content);
  });
  var removed = newTokens.filter(function (token) {
    return !oldTokensSet.has(token.content);
  });
  return [added, removed];
}

var Scope = /*#__PURE__*/function () {
  function Scope(instance) {
    var _this5 = this;

    _classCallCheck(this, Scope);

    this.instance = instance;

    this.scopedTarget = function (element) {
      return element.closest(_this5.identifier) === _this5.instance;
    };

    this.instance = instance;
  }

  _createClass(Scope, [{
    key: "findTarget",
    value: function findTarget(selector) {
      return this.instance.matches(selector) ? this.instance : this.getElements(selector).find(this.scopedTarget) || null;
    }
  }, {
    key: "findTargets",
    value: function findTargets(selector) {
      return [].concat(_toConsumableArray(this.instance.matches(selector) ? [this.instance] : []), _toConsumableArray(this.getElements(selector).filter(this.scopedTarget)));
    }
  }, {
    key: "getElements",
    value: function getElements(selector) {
      return Array.from(this.instance.querySelectorAll(selector));
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Scope;
}();

var ATTRIBUTE_NAME = 'data-action';

var Action = /*#__PURE__*/function () {
  function Action(instance) {
    _classCallCheck(this, Action);

    this.instance = instance;
    this.eventListenerMap = new SetMap();
    this.instance = instance;
    this.scope = new Scope(this.instance);
  }

  _createClass(Action, [{
    key: "start",
    value: function start() {
      if (!this.tokenListObserver) {
        this.tokenListObserver = new TokenListObserver(this.instance, ATTRIBUTE_NAME, this);
        this.tokenListObserver.start();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.tokenListObserver) {
        this.destroyActions();
        this.tokenListObserver.stop();
        this.tokenListObserver = undefined;
      }
    }
  }, {
    key: "tokenMatched",
    value: function tokenMatched(_ref6) {
      var content = _ref6.content,
          element = _ref6.element;

      var _a = parseActionDescriptor(content),
          identifier = _a.identifier,
          eventTarget = _a.eventTarget,
          options = __rest(_a, ["identifier", "eventTarget"]);

      if (options.eventName && identifier === this.identifier && options.methodName && this.scope.scopedTarget(element)) {
        var eventListener = new EventListener(this.instance, Object.assign(Object.assign({}, options), {
          eventTarget: eventTarget || element
        }));
        this.eventListenerMap.add(element, eventListener);
        eventListener.start();
      }
    }
  }, {
    key: "tokenUnmatched",
    value: function tokenUnmatched(_ref7) {
      var element = _ref7.element;
      var eventListeners = this.eventListenerMap.get(element);
      if (!eventListeners) return;

      var _iterator7 = _createForOfIteratorHelper(eventListeners),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var eventListener = _step7.value;
          eventListener.stop();
          this.eventListenerMap.delete(element, eventListener);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "destroyActions",
    value: function destroyActions() {
      var _a;

      var _iterator8 = _createForOfIteratorHelper(this.eventListenerMap.keys),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _target = _step8.value;
          (_a = this.tokenListObserver) === null || _a === void 0 ? void 0 : _a.elementDisconnected(_target);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Action;
}();
/**
 * Returns a promise that is fulfilled when the document's `readyState` is `complete`.
 */


function domReady() {
  return new Promise(function (resolve) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        return resolve();
      });
    } else {
      resolve();
    }
  });
}

var STRING_CAMELIZE_REGEXP_1 = /(-|_|\.|\s)+(.)?/g;
var STRING_CAMELIZE_REGEXP_2 = /(^|\/)([A-Z])/g;
var STRING_DASHERIZE_REGEXP = /[ _]/g;
var STRING_DECAMELIZE_REGEXP = /([a-z\d])([A-Z])/g;
/**
 * Returns the lowerCamelCase form of a string.
 *
 * @example
 * camelize('innerHTML');
 * //=> innerHTML
 *
 * camelize('action_name');
 * //=> actionName
 *
 * camelize('css-class-name');
 * //=> cssClassName
 *
 * camelize('my favorite items');
 * //=> myFavoriteItems
 *
 * camelize('My Favorite Items');
 * //=> myFavoriteItems
 *
 * camelize('private-docs/owner-invoice');
 * //=> privateDocs/ownerInvoice
 */

function camelize(value) {
  return value.replace(STRING_CAMELIZE_REGEXP_1, function (_match, _separator, chr) {
    return chr ? chr.toUpperCase() : '';
  }).replace(STRING_CAMELIZE_REGEXP_2, function (match) {
    return match.toLowerCase();
  });
}
/**
 * Replaces underscores, spaces, or camelCase with dashes.
 *
 * @example
 * dasherize('innerHTML');
 * //=> inner-html
 *
 * dasherize('action_name');
 * //=> action-name
 */


function dasherize(value) {
  return decamelize(value).replace(STRING_DASHERIZE_REGEXP, '-');
}
/**
 * Converts a camelized string into all lower case separated by underscores.
 *
 * @example
 * decamelize('innerHTML');
 * //=> inner_html
 */


function decamelize(value) {
  return value.replace(STRING_DECAMELIZE_REGEXP, '$1_$2').toLowerCase();
}
/**
 * Returns the capitalized form of a string.
 *
 * @example
 * capitalize('innerHTML');
 * //=> InnerHTML
 */


function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
/**
 * Returns the output of JSON.parse or fallbacks to a specified default value.
 *
 * @example
 * parseJSON('[]');
 * //=> []
 *
 * parseJSON(undefined, '');
 * //=> ''
 */


function parseJSON(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (_a) {
    return fallback;
  }
}

var Property = /*#__PURE__*/function () {
  function Property(instance) {
    _classCallCheck(this, Property);

    this.instance = instance;
    this.instance = instance;
    this.store = new Store(Object.getPrototypeOf(this.instance), 'property');
  }

  _createClass(Property, [{
    key: "start",
    value: function start() {
      var _iterator9 = _createForOfIteratorHelper(this.properties.entries()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _ref10 = _step9.value;

          var _ref9 = _slicedToArray(_ref10, 1);

          var _ref9$ = _ref9[0];
          var key = _ref9$.key;
          var type = _ref9$.type;
          this.initializeProperty(key, type);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {//
    }
  }, {
    key: "initializeProperty",
    value: function initializeProperty(key, type) {
      var _a;

      var attributeName = dasherize(key);
      var defaultValue = this.instance[key];
      var descriptor = Object.assign({
        configurable: true
      }, descriptorProperties(this.instance, attributeName, type));
      Object.defineProperty(this.instance, key, descriptor);

      if (!this.instance.hasAttribute(attributeName)) {
        (_a = descriptor.set) === null || _a === void 0 ? void 0 : _a.call(descriptor, defaultValue);
      }
    }
  }, {
    key: "properties",
    get: function get() {
      return this.store.value;
    }
  }]);

  return Property;
}();

function descriptorProperties(element, attributeName, type) {
  switch (type) {
    case Number:
      return {
        get: function get() {
          var _a;

          return Number(((_a = element.getAttribute(attributeName)) === null || _a === void 0 ? void 0 : _a.replace(/_/g, '')) || 0);
        },
        set: function set(value) {
          return element.setAttribute(attributeName, (value || 0).toString());
        }
      };

    case Boolean:
      return {
        get: function get() {
          return element.hasAttribute(attributeName) && element.getAttribute(attributeName) !== 'false';
        },
        set: function set(value) {
          // Simply toggling the attribute will not work.
          if (value) {
            element.setAttribute(attributeName, '');
          } else {
            element.removeAttribute(attributeName);
          }
        }
      };

    case Array:
      return {
        get: function get() {
          return JSON.parse(element.getAttribute(attributeName) || '[]');
        },
        set: function set(value) {
          return element.setAttribute(attributeName, JSON.stringify(value) || '[]');
        }
      };

    case Object:
      return {
        get: function get() {
          return JSON.parse(element.getAttribute(attributeName) || '{}');
        },
        set: function set(value) {
          return element.setAttribute(attributeName, JSON.stringify(value) || '{}');
        }
      };

    default:
      return {
        get: function get() {
          return element.getAttribute(attributeName) || '';
        },
        set: function set(value) {
          return element.setAttribute(attributeName, value || '');
        }
      };
  }
}

var Target = /*#__PURE__*/function () {
  function Target(instance) {
    _classCallCheck(this, Target);

    this.instance = instance;
    this.instance = instance;
    this.store = new Store(Object.getPrototypeOf(this.instance), 'target');
    this.scope = new Scope(this.instance);
    this.targetsByKey = new SetMap();
  }

  _createClass(Target, [{
    key: "start",
    value: function start() {
      // Initialize targets with an empty array if it references multiple targets, or with null if it references a single
      // target. Later, if we find matching targets, we set them accordingly. If we don't, we can still iterate over
      // targets because it is an array.
      var _iterator10 = _createForOfIteratorHelper(this.keys),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var key = _step10.value;
          this.defineProperty(key, this.isKeyMultiple(key) ? [] : null);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      if (!this.tokenListObserver) {
        this.tokenListObserver = new TokenListObserver(this.instance, 'data-target', this);
        this.tokenListObserver.start();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.tokenListObserver) {
        this.destroyTargets();
        this.tokenListObserver.stop();
        this.tokenListObserver = undefined;
      }
    }
  }, {
    key: "tokenMatched",
    value: function tokenMatched(_ref11) {
      var content = _ref11.content,
          element = _ref11.element;

      var _content$split = content.split('.'),
          _content$split2 = _slicedToArray(_content$split, 2),
          identifier = _content$split2[0],
          key = _content$split2[1];

      if (!this.isValidIdKeyPair(identifier, key) || this.targetsByKey.has(key, element)) return; // Check if the target is within the scope of the instance.

      if (!this.scope.scopedTarget(element)) return;
      this.targetsByKey.add(key, element);
      var targets = this.targetsByKey.getValuesForKey(key);

      if (targets.length > 1 && !this.isKeyMultiple(key)) {
        throw new Error("\nMultiple \"".concat(key, "\" targets in the \"").concat(identifier, "\" element were defined using the @target() decorator.\nPlease use the @targets() decorator instead if you want to define multiple targets for the same key.\nLearn more about the @targets() decorator: https://ambiki.github.io/impulse/reference/targets.html#multiple-targets\n        "));
      }

      this.defineProperty(key, this.isKeyMultiple(key) ? targets : element);
      this.invokeCallback(key, element, 'connected');
    }
  }, {
    key: "tokenUnmatched",
    value: function tokenUnmatched(_ref12) {
      var content = _ref12.content,
          element = _ref12.element;

      var _content$split3 = content.split('.'),
          _content$split4 = _slicedToArray(_content$split3, 2),
          identifier = _content$split4[0],
          key = _content$split4[1];

      if (!this.isValidIdKeyPair(identifier, key) || !this.targetsByKey.has(key, element)) return;
      this.targetsByKey.delete(key, element);
      this.invokeCallback(key, element, 'disconnected'); // Update property after invoking callback.

      this.defineProperty(key, this.isKeyMultiple(key) ? this.targetsByKey.getValuesForKey(key) : null);
    }
  }, {
    key: "destroyTargets",
    value: function destroyTargets() {
      var _this6 = this;

      var _iterator11 = _createForOfIteratorHelper(this.targetsByKey.keys),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var name = _step11.value;

          var _targets = this.targetsByKey.getValuesForKey(name);

          _targets.forEach(function (target) {
            var _a;

            return (_a = _this6.tokenListObserver) === null || _a === void 0 ? void 0 : _a.elementDisconnected(target);
          });
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "defineProperty",
    value: function defineProperty(key, result) {
      Object.defineProperty(this.instance, key, {
        configurable: true,
        get: function get() {
          return result;
        }
      });
    }
  }, {
    key: "isValidIdKeyPair",
    value: function isValidIdKeyPair(identifier, key) {
      if (!key || identifier !== this.identifier || !this.keys.includes(key)) {
        return false;
      }

      return true;
    }
  }, {
    key: "invokeCallback",
    value: function invokeCallback(key, target, suffix) {
      var fn = this.instance["".concat(key).concat(capitalize(suffix))];

      if (typeof fn === 'function') {
        fn.call(this.instance, target);
      }
    }
  }, {
    key: "isKeyMultiple",
    value: function isKeyMultiple(key) {
      var _a, _b;

      return (_b = (_a = Array.from(this.targetKeys).find(function (t) {
        return t.key === key;
      })) === null || _a === void 0 ? void 0 : _a.multiple) !== null && _b !== void 0 ? _b : false;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.targetKeys).map(function (_ref13) {
        var key = _ref13.key;
        return key;
      });
    }
  }, {
    key: "targetKeys",
    get: function get() {
      return this.store.value;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Target;
}();

var ImpulseElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ImpulseElement, _HTMLElement);

  var _super = _createSuper(ImpulseElement);

  function ImpulseElement() {
    var _this7;

    _classCallCheck(this, ImpulseElement);

    _this7 = _super.apply(this, arguments);
    _this7.property = new Property(_assertThisInitialized(_this7));
    _this7.target = new Target(_assertThisInitialized(_this7));
    _this7.action = new Action(_assertThisInitialized(_this7));
    _this7._started = false;
    return _this7;
  }

  _createClass(ImpulseElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this._started) {
        this._asyncConnect();
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, _oldValue, _newValue) {
      if (!this._started || _oldValue === _newValue) return;
      var camelizedName = camelize(name);
      var fn = this["".concat(camelizedName, "Changed")];
      if (typeof fn !== 'function') return;
      var store = new Store(Object.getPrototypeOf(this), 'property');
      var propertyArray = Array.from(store.value).map(function (_ref14) {
        var key = _ref14.key,
            type = _ref14.type;
        return {
          key: key,
          type: type
        };
      });
      var property = propertyArray.find(function (_ref15) {
        var key = _ref15.key;
        return key === camelizedName;
      });

      if (!property) {
        throw new Error("Unregistered attribute changed: ".concat(name, ". Register the attribute using the @property() decorator."));
      } // Validate if value changed after transformation.
      // Common case would be:
      // -> 8_000 to 8000


      var _attributeValueTransf = attributeValueTransformer(_newValue, _oldValue, property.type),
          newValue = _attributeValueTransf.newValue,
          oldValue = _attributeValueTransf.oldValue;

      if (newValue === oldValue) return;
      fn.call(this, newValue, oldValue);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._started) {
        // Order is important
        this.disconnected();
        this.action.stop();
        this.target.stop();
        this.property.stop();
        this._started = false;
      }
    }
  }, {
    key: "connected",
    value: function connected() {// Override in your subclass to respond when the element is connected to the DOM.
    }
  }, {
    key: "disconnected",
    value: function disconnected() {// Override in your subclass to respond when the element is removed from the DOM.
    }
    /**
     * Emits a custom event from the element.
     */

  }, {
    key: "emit",
    value: function emit(name) {
      var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a$target = _a.target,
          target = _a$target === void 0 ? this : _a$target,
          _a$prefix = _a.prefix,
          prefix = _a$prefix === void 0 ? this.identifier : _a$prefix,
          _a$detail = _a.detail,
          detail = _a$detail === void 0 ? {} : _a$detail,
          rest = __rest(_a, ["target", "prefix", "detail"]);

      var eventName = prefix ? "".concat(prefix, ":").concat(name) : name;
      var event = new CustomEvent(eventName, Object.assign({
        bubbles: true,
        composed: true,
        detail: detail
      }, rest));
      target.dispatchEvent(event);
      return event;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.tagName.toLowerCase();
    }
  }, {
    key: "_asyncConnect",
    value: function () {
      var _asyncConnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return domReady();

              case 2:
                customElements.upgrade(this); // Order is important

                this.property.start(); // Resolve all undefined elements before initializing the target/targets so that property references can be resolved
                // to the assigned value.

                _context.next = 6;
                return this._resolveUndefinedElements();

              case 6:
                this.target.start();
                this.action.start();
                this._started = true;
                this.setAttribute('data-impulse-element', '');
                this.connected();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _asyncConnect() {
        return _asyncConnect2.apply(this, arguments);
      }

      return _asyncConnect;
    }()
  }, {
    key: "_resolveUndefinedElements",
    value: function _resolveUndefinedElements() {
      var undefinedElements = Array.from(this.querySelectorAll(':not(:defined)'));
      var promises = undefinedElements.map(function (element) {
        return customElements.whenDefined(element.localName);
      });
      return Promise.all(promises);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var store = new Store(this.prototype, 'property');
      return Array.from(store.value).map(function (_ref16) {
        var key = _ref16.key;
        return dasherize(key);
      });
    }
  }]);

  return ImpulseElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function attributeValueTransformer(_newValue, _oldValue, type) {
  switch (type) {
    case Boolean:
      {
        var transform = function transform(value) {
          return value !== null && value !== 'false';
        };

        return {
          newValue: transform(_newValue),
          oldValue: transform(_oldValue)
        };
      }

    case Number:
      {
        var _transform = function _transform(value) {
          return value === null || value === void 0 ? void 0 : value.replace(/_/g, '');
        };

        return {
          newValue: Number(_transform(_newValue)),
          oldValue: Number(_transform(_oldValue))
        };
      }

    case Array:
      return {
        newValue: parseJSON(_newValue, []),
        oldValue: parseJSON(_oldValue, [])
      };

    case Object:
      return {
        newValue: parseJSON(_newValue, {}),
        oldValue: parseJSON(_oldValue, {})
      };

    default:
      return {
        newValue: _newValue,
        oldValue: _oldValue
      };
  }
}

var lazyElements = new SetMap();
/**
 * Lazy import helps improve the initial loading performance of an application by including them only when the element
 * is present in the DOM.
 *
 * Although HTML classes as selectors are supported, it is recommended to use data attributes such as `data-js-load-billing`.
 *
 * @param selector - The selector to match the elements.
 * @param callback - The callback to execute when the element is present in the DOM.
 *
 * @example
 * lazyImport('my-element', () => import('./my_element'));
 * lazyImport('[data-cc-form]', () => import('./billing/credit_card_form'));
 */

function lazyImport(selector, callback) {
  lazyElements.add(selector, callback);
  var observer = new ElementObserver(document.documentElement, {
    elementConnected: function elementConnected() {
      var _iterator12 = _createForOfIteratorHelper(lazyElements.keys),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _selector = _step12.value;

          var _iterator13 = _createForOfIteratorHelper(lazyElements.get(_selector) || []),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _callback = _step13.value;
              domReady().then(_callback);
              lazyElements.deleteKey(_selector);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    },
    getMatchingElements: function getMatchingElements(element) {
      var elements = Array.from(element.querySelectorAll(selector));

      if (element.matches(selector)) {
        elements.unshift(element);
      }

      return elements;
    }
  });
  observer.start();
}

export { AttributeObserver, ElementObserver, ImpulseElement, TokenListObserver, lazyImport, property, registerElement, target, targets };